import { useEffect } from 'react';
import { Link } from 'react-router';
import { PrimeLogo } from '@/assets/prime-logo.tsx';

const loader = document.querySelector('.loader-container')!;
const hideLoader = () => loader.classList.add('loader--hide');

const NotFoundPage = () => {
  useEffect(() => {
    hideLoader();
  }, []);

  return (
    <div className="flex h-svh flex-col justify-between bg-white">
      <main className="flex flex-1 flex-col items-center justify-center px-4">
        <div className="flex w-full max-w-2xl flex-col items-center gap-12">
          <PrimeLogo
            width="100%"
            height="100%"
            withText={false}
            className="size-[100px] sm:size-[150px]"
          />
          <div className="flex flex-col items-center gap-6 text-center">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
              Page Not Found
            </h1>
            <p className="text-base leading-7 text-gray-600 sm:text-lg sm:leading-8">
              Sorry, we couldn't find the page you're looking for. The page may have been
              moved, deleted, or never existed.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link
                to="/"
                className="rounded-md bg-gray-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-gray-800"
              >
                Return Home
              </Link>
              <a
                href="mailto:support@app.primebatteries.com"
                className="rounded-md bg-gray-100 px-4 py-2.5 text-sm font-semibold text-gray-900 hover:bg-gray-200"
              >
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotFoundPage;
